import { useMemo } from "react";
import { TimeSeriesLineChart } from "../../../features/Charts/LineCharts/TimeSeriesLineChart";
import { useGetMeasurmentColor } from "../../../hooks/useGetMeasurmentColor";
import { graces } from "../../Devices/SensorAnalog";
import { useStyletron } from "baseui";

export function TrendPanel({
    temperature,
    humidity,
    pressure
}) {
    const [css,theme] = useStyletron();
    const [colortemperature] = useGetMeasurmentColor(temperature?.dimension);
    const [colorhumidity] = useGetMeasurmentColor(humidity?.dimension);
    const [colorpressure] = useGetMeasurmentColor(pressure?.dimension);

    const lines = useMemo(() => {
        var tmp: any[] = [];
        if (temperature) tmp.push({
            label: `${temperature.description}`,
            lineColor: colortemperature,
            showMinMax: true,
            fill: false,
            objectId: temperature.id,
            resourceGroupId: temperature.resourceGroupId,
            propertyName: 'value',
            currentValue: temperature.value,
            showPoints: false,
            grace: graces[temperature.dimension]
        });
        if (humidity) tmp.push({
            yScaleId: 'y1',
            label: `${humidity.description}`,
            lineColor: colorhumidity,
            showMinMax: true,
            fill: false,
            objectId: humidity.id,
            resourceGroupId: humidity.resourceGroupId,
            propertyName: 'value',
            currentValue: humidity.value,
            showPoints: false,
            grace: graces[humidity.dimension]
        });
        if (pressure) tmp.push({
            yScaleId: 'y2',
            label: `${pressure.description}`,
            lineColor: colorpressure,
            showMinMax: true,
            fill: false,
            objectId: pressure.id,
            resourceGroupId: pressure.resourceGroupId,
            propertyName: 'value',
            currentValue: pressure.value,
            showPoints: false,
            grace: graces[pressure.dimension]
        }
        );
        return tmp;
    }, [temperature, humidity, pressure]);

    return <div className={css({ height: '100%', width: '100%' })}>
        {lines.length > 0 &&
            <TimeSeriesLineChart
                lines={lines}
                timespan={7 * 24 * 60}
                summarizeBy={"1h"} showAverage={false} showLegend={false}></TimeSeriesLineChart>
        }
    </div>;
}
